// Wording for arrive-by alerts (spec 003), the same as the apps' shared
// ArriveBy, from i18n/common (spec 013 FR-010).
import type { ArriveByAlert } from '../api/types';
import { locale, t, time } from '../i18n/index.ts';

// arriveByTime is "8:15 AM" from "08:15", in the viewer's clock.
export function arriveByTime(hhmm: string): string {
  const [h, m] = hhmm.split(':').map(Number);
  return time(new Date(2000, 0, 1, h, m));
}

// arriveByDays says when an alert applies: "Weekdays", "Every day", "Mondays and Fridays", or "Once, on Sat, Oct 3".
export function arriveByDays(a: Pick<ArriveByAlert, 'date' | 'weekdays'>): string {
  if (a.date) {
    const [y, mo, d] = a.date.split('-').map(Number);
    const day = new Intl.DateTimeFormat(locale(), { weekday: 'short', month: 'short', day: 'numeric' }).format(new Date(y, mo - 1, d));
    return t('arrivebyOnce', { date: day });
  }
  const days = [...a.weekdays].sort();
  if (days.length === 7) return t('arrivebyEveryDay');
  if (days.join() === '1,2,3,4,5') return t('arrivebyWeekdays');
  if (days.join() === '0,6') return t('arrivebyWeekends');
  return new Intl.ListFormat(locale(), { type: 'conjunction' }).format(days.map((d) => t('arrivebyEvery', { day: d })));
}

// arriveByZone is " (New York time)" for an alert kept in a time zone other
// than the browser's, whose deadline would otherwise read as local; else "".
export function arriveByZone(tz: string): string {
  if (!tz || tz === Intl.DateTimeFormat().resolvedOptions().timeZone) return '';
  const city = tz.split('/').pop()?.replaceAll('_', ' ') ?? tz;
  return ` ${t('arrivebyZone', { city })}`;
}
